import { ref, Ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { SelectOption } from "@/business/shared/commons/selectOption";
import { IdType } from "@/business/clients/domain/idType";
import { getIdTypes } from "@/business/clients/application/getIdTypes";
import { getIdTypesLikeSelectOption } from "@/business/clients/application/getIdTypesLikeSelectOption";
import { createClient } from "@/business/clients/application/createClient";
import { updateClient } from "@/business/clients/application/updateClient";
import { clientStore } from "@/business/clients/infrastructure/store/clientStore";
import { getClientSession } from "@/business/clients/application/getClientSession";
import { Client } from "@/business/clients/domain/clients";

export function createEditClientUse() {
    const router = useRouter();
    const idTypeList: Ref<SelectOption[]> = ref([]);
    const idTypes: Ref<IdType[]> = ref([]);
    const isEmpty: Ref<boolean> = ref(clientStore().isEmpty);
    const actualClient: Ref<Client | null> = ref(getClientSession.execute());

    onMounted(async () => {
        idTypes.value = await getIdTypes.execute();
        idTypeList.value = await getIdTypesLikeSelectOption.execute(idTypes.value);
    });

    async function backClientsOption() {
        actualClient.value = null;
        await router.push("/administrator/clients");
    }

    async function createClientOperation(
        identificationType: string,
        identificationNumber: string,
        company: string,
        contactName: string,
        contactEmail: string,
        contactPhone: number,
        billingEmail: string,
        isSameEmail: boolean
    ) {
        await createClient.execute(
            identificationType,
            identificationNumber,
            company,
            contactName,
            contactEmail,
            contactPhone,
            billingEmail,
            isSameEmail
        );
    }

    async function updateClientOperation(
        identificationType: string,
        identificationNumber: string,
        company: string,
        contactName: string,
        contactEmail: string,
        contactPhone: number,
        billingEmail: string,
        isSameEmail: boolean
    ) {
        await updateClient.execute(
            actualClient.value?.clientId ?? "",
            identificationType,
            identificationNumber,
            company,
            contactName,
            contactEmail,
            contactPhone,
            billingEmail,
            isSameEmail
        );
    }

    return {
        idTypeList,
        idTypes,
        isEmpty,
        actualClient,
        backClientsOption,
        createClientOperation,
        updateClientOperation,
    };
}
